import { render, staticRenderFns } from "./IcoPaper2.vue?vue&type=template&id=edebd5e6"
import script from "./IcoPaper2.vue?vue&type=script&lang=js"
export * from "./IcoPaper2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports